import { FlatTreeControl } from '@angular/cdk/tree';
import { Component, ViewChild, Output, EventEmitter, SimpleChanges, OnDestroy } from '@angular/core';
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';
import { LanguageService, TreeService } from '@shared/services';
import { MatSort } from '@angular/material/sort';
import { first, takeUntil } from 'rxjs/operators';
import { SelectionModel } from '@angular/cdk/collections';
import { MatTableDataSource } from '@angular/material/table';
import { ResourcesService } from '@shared/services/resources.service';
import { Input } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';

interface ExampleFlatNode {
    expandable: boolean;
    name: string;
    level: number;
}

/**
 * @title Tree with flat nodes
 */
@Component({
    selector: 'app-search-rcategoryes-tree',
    templateUrl: './search-rcategoryes-tree.component.html',
    styleUrls: ['./search-rcategoryes-tree.component.scss']
})
export class SearchRCategoryesTreeComponent implements OnDestroy {
    loading = true;
    resourceLst = [];
    constructor(
        public router: Router,
        private langservice: LanguageService,
        private _treeService: TreeService,
        private _resourceService: ResourcesService
    ) {
        if (this.IsRole == true || this.isForReports == true) {
            this.currSelectedRess = [];
            this.selection = new SelectionModel(true);
            this.selectedResource = new EventEmitter<any>();
            this.selectedResources = new EventEmitter<any>();
        }
    }
    private _unsubscribeAll$ = new Subject<boolean>();

    dbselectresource(row) {
        this.selectedResource.emit(row);
        this.activeStyleUserTable = row.resourceId;
        this.IsDbClickAction.emit(true);

        // this.selection = row;
    }
    activeStyleNode = '';
    TREE_DATA: any;

    treeControl = new FlatTreeControl<ExampleFlatNode>(
        (node) => node.level,
        (node) => node.expandable
    );

    treeFlattener = new MatTreeFlattener(
        this.transformer,
        (node) => node.level,
        (node) => node.expandable,
        (node) => node.childs
    );
    @Output('IsDbClickAction')
    IsDbClickAction: EventEmitter<any> = new EventEmitter<any>();
    dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);
    @Input('EnableDoubleClickSelection')
    EnableDoubleClickSelection: false;
    @Input('canEdit')
    canEdit = true;

    @Input('RoleResourceList')
    RoleResourceList = [];

    @Input('IsRole')
    IsRole = false;

    @Input('rememberSelection')
    rememberSelection = false;

    @Input('isForReports')
    isForReports = false;

    @Input('multiselect')
    multiselect = true;
    @Output('selectedResource')
    selectedResource: EventEmitter<any> = new EventEmitter<any>();

    @Output('selectedResources')
    selectedResources: EventEmitter<any> = new EventEmitter<any>();

    @Input('currSelectedRess')
    currSelectedRess = [];
    @Input('FixedTimeList')
    FixedTimeList = null;
    @Input('IsFixedTime')
    IsFixedTime = false;

    @Input('timeSlotsType')
    timeSlotsType = null;
    @Input('ExcludeFixedBookingResources')
    ExcludeFixedBookingResources = false;
    @Input('ExcludeInventoryAndCapcityResource')
    ExcludeInventoryAndCapcityResource = false;

    @ViewChild(MatSort, { static: true }) sort: MatSort;
    displayedColumns: string[] = [
        'select',
        'addToFav',
        'resourceName',
        'locationName',
        'timeSlotType',
        'multibookingflag'
    ];
    tableData = new MatTableDataSource([]);
    selection = new SelectionModel(true, []);

    activeStyleUserTable = '';
    selectedCat = '';
    transformer(node: any, level: number) {
        return {
            expandable: !!node.childs && node.childs.length > 0,
            name: node.resourceCategoryName,
            id: node.resourceCategoryId,
            level: level
        };
    }
    getTreeCategory() {
        this._treeService
            .getTreeCategory()
            .pipe(takeUntil(this._unsubscribeAll$), first())
            .subscribe((result) => {
                this.dataSource.data = result.data;
                this.loading = false;
            });
    }

    IsRoleResource(tableElment) {
        if (this.IsRole && this.RoleResourceList.length > 0) {
            this.RoleResourceList.forEach((r) => {
                this.tableData.data.forEach((row) => {
                    if (r.resourceid == row.resourceId) {
                        row.accessType = r.accessType;
                        this.selection.select(row);
                    }
                });
            });
            var check = this.RoleResourceList.find((e) => e.resourceid == tableElment.resourceId);

            if (check) {
                return true;
            }
            return false;
        }
        return false;
    }
    setStyle(addTofav) {
        return { color: 'black' };
    }
    AddToFav(row) {
        var favRes = { resourceId: row.resourceId };
        var fav = [];
        if (row.addToFav != true) {
            this._resourceService
                .AddToFav(favRes)
                .pipe(takeUntil(this._unsubscribeAll$), first())
                .subscribe((result) => {
                    if (result.data != null) {
                        row.addToFav = true;
                        this.getFavList();
                    }
                });
        } else {
            fav.push(favRes);
            this._resourceService
                .RemoveFromFav(fav)
                .pipe(takeUntil(this._unsubscribeAll$), first())
                .subscribe((result) => {
                    if (result) {
                        row.addToFav = false;
                        this.getFavList();
                    }
                });
        }
    }
    getFavList() {
        this._resourceService
            .getFavList()
            .pipe(takeUntil(this._unsubscribeAll$), first())
            .subscribe((result) => {
                if (result.data != null) {
                    if (result.data.length != 0)
                        localStorage.setItem('lastSelectedResources', JSON.stringify(result.data));
                }
            });
    }
    accessType = [
        { value: '2', accessType: 'Add' },
        { value: '3', accessType: 'Edit' },
        { value: '5', accessType: 'Delete' }
    ];
    ngOnInit() {
        if (this.IsRole) {
            // this.getAccessTypes();
            //  this.rememberSelection=false
            this.displayedColumns = ['select', 'resourceName', 'locationName', 'accesstype'];
        }

        if (this.isForReports) {
            this.displayedColumns = ['select', 'resourceName', 'locationName'];
        }
        this.getTreeCategory();
        this.selection.changed.next = (val) => {
            if (this.IsRole == true) {
                this.selection.selected.forEach((element) => {
                    var check = this.RoleResourceList.find((e) => e.resourceid == element.resourceId);
                    if (check) {
                        if (check.accessType == '8') element.accessTypeList = ['2', '3', '5'];
                        else if (check.accessType == '7') {
                            element.accessTypeList = ['3', '5'];
                        } else if (check.accessType == '6') {
                            element.accessTypeList = ['2', '5'];
                        } else if (check.accessType == '4') {
                            element.accessTypeList = ['2', '3'];
                        } else {
                            if (check.accessType != '1') element.accessTypeList = [check.accessType];
                        }
                    } else {
                        if (element.accessType == null) {
                            element.accessType = '1';
                        }
                    }
                });
            }

            this.selectedResources.emit(val);
        };
    }

    applyAccessType(element, event) {
        if (event.length == 1) element.accessType = event[0];
        if (event.length == 3) element.accessType = '8';

        if (event.length == 2) {
            if (event.find((e) => e == '2') && event.find((e) => e == '3')) {
                element.accessType = '4';
            }
            if (event.find((e) => e == '2') && event.find((e) => e == '5')) {
                element.accessType = '6';
            }
            if (event.find((e) => e == '3') && event.find((e) => e == '5')) {
                element.accessType = '7';
            }
        }
    }
    getAccessTypes() {
        this.langservice
            .GetLookupbyKey('ResourceAccessType')
            .pipe(takeUntil(this._unsubscribeAll$), first())
            .subscribe((result) => {
                this.accessType = result.data;
            });
    }
    ngOnChanges(changes: SimpleChanges) {
        if (this.isForReports) {
            if (changes['currSelectedRess']) {
                if (changes.currSelectedRess.currentValue.length < 1) {
                    this.selection.clear();
                }
            }
        } else {
            if (!this.multiselect) {
                this.displayedColumns.splice(0, 1);
            }
        }
    }
    reloadafterdeletion() {
        this.selection = new SelectionModel(true, []);
        this.tableData = new MatTableDataSource();
        this.getTreeCategory();
        if (this.selectedCat !== '') {
            this.getresbycatid(this.selectedCat);
        } else {
            this.tableData = new MatTableDataSource();
        }
    }
    getselectedResources() {
        this.selectedResource.emit(this.selection.selected);
    }
    selectresource(row) {
        this.activeStyleUserTable = row.resourceId;
        //this.selection = row;
        this.selectedResource.emit(row);
    }
    nodeClick(node) {
        this.activeStyleNode = node.id;
        this.selectedCat = node.id;
        this.getresbycatid(node.id);
        // console.log(node);
    }
    getresbycatid(id) {
        this._resourceService
            .getresourcesbycatid(
                id,
                this.timeSlotsType,
                this.ExcludeFixedBookingResources,
                this.ExcludeInventoryAndCapcityResource
            )
            .pipe(takeUntil(this._unsubscribeAll$), first())
            .subscribe((result) => {
                this.resourceLst = result.data;
                this.tableData = new MatTableDataSource(result.data);

                if (
                    this.rememberSelection &&
                    this.tableData.data &&
                    this.tableData.data.length > 0 &&
                    this.currSelectedRess &&
                    this.currSelectedRess.length > 0
                ) {
                    this.currSelectedRess.forEach((r) => {
                        this.tableData.data.forEach((row) => {
                            if (r.resourceId == row.resourceId) this.selection.select(row);

                            if (this.isForReports) this.selection.select(row);
                        });
                    });
                }
            });
    }
    hasChild = (_: number, node: ExampleFlatNode) => node.expandable;

    editResource(row) {
        if (this.canEdit) this.router.navigate(['resource', row.resourceId]);
    }
    isAllSelected() {
        const numSelected = this.selection.selected.length;
        const numRows = this.tableData.data.length;
        return numSelected === numRows;
    }

    masterToggle() {
        this.isAllSelected()
            ? this.selection.clear()
            : this.tableData.data.forEach((row) => this.selection.select(row));
        // this.selectedResource.emit(this.selection.selected);
    }

    checkboxLabel(row): string {
        if (!row) {
            return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
        }
        return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.email + 1}`;
    }
    CheckExist(Id) {
        if (!this.FixedTimeList) {
            return false;
        }
        const findBooking = (element) => element.resourceId == Id;
        const Res = this.FixedTimeList.findIndex(findBooking);
        if (Res > -1) {
            if (this.FixedTimeList[Res].hasOwnProperty('isClosed')) {
                if (this.FixedTimeList[Res].isClosed === true) return false;
                else return true;
            }
            return true;
        }
        return false;
    }

    ngOnDestroy(): void {
        this._unsubscribeAll$.next(true);
        this._unsubscribeAll$.complete();
    }
}

/**  Copyright 2019 Google LLC. All Rights Reserved.
    Use of this source code is governed by an MIT-style license that
    can be found in the LICENSE file at http://angular.io/license */
